var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDislike = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6631 1.33337V8.66671M14.9965 6.53337V3.46671C14.9965 2.71997 14.9965 2.3466 14.8511 2.06139C14.7233 1.8105 14.5193 1.60653 14.2684 1.4787C13.9832 1.33337 13.6099 1.33337 12.8631 1.33337H5.7418C4.76747 1.33337 4.28031 1.33337 3.88684 1.51166C3.54005 1.6688 3.24532 1.92166 3.03728 2.24052C2.80123 2.6023 2.72716 3.0838 2.57901 4.04679L2.23029 6.31346C2.03488 7.58358 1.93718 8.21864 2.12566 8.71279C2.29108 9.1465 2.60222 9.50917 3.00574 9.73862C3.46548 10 4.10801 10 5.39308 10H5.92979C6.30316 10 6.48984 10 6.63245 10.0727C6.75789 10.1366 6.85988 10.2386 6.92379 10.364C6.99645 10.5067 6.99645 10.6933 6.99645 11.0667V13.0228C6.99645 13.9307 7.73245 14.6667 8.64035 14.6667C8.8569 14.6667 9.05313 14.5392 9.14108 14.3413L11.3816 9.30016C11.4835 9.07087 11.5344 8.95623 11.615 8.87217C11.6862 8.79786 11.7736 8.74104 11.8704 8.70616C11.98 8.66671 12.1054 8.66671 12.3563 8.66671H12.8631C13.6099 8.66671 13.9832 8.66671 14.2684 8.52138C14.5193 8.39355 14.7233 8.18958 14.8511 7.93869C14.9965 7.65348 14.9965 7.28011 14.9965 6.53337Z",
    stroke: "#D1D1D1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDislike, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/dislike.e2f24b8d.svg";
export { ForwardRef as ReactComponent };